import { FC } from "react";
import { useTitlePage } from "../hooks/use-title-page";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Apple, ShopTwo } from "@mui/icons-material";

const APP_STORE_URL = "https://apps.apple.com/il/app/אחד/id6472609355";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.yinon_dev.echad";

const title = "הורדת האפליקציה";

const DownloadAppPage: FC = () => {
  useTitlePage(title);

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #f8f9ff 0%, #e8ecff 100%)",
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Stack spacing={4} alignItems="center">
          {/* Logo */}
          <Box
            sx={{
              width: 140,
              height: 140,
              borderRadius: "28px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(102, 126, 234, 0.3)",
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <img
              src="/android-chrome-512x512.png"
              alt="אחד - לוגו"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          {/* App Info */}
          <Stack spacing={1} alignItems="center" textAlign="center">
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontWeight: 700,
                color: "#2d3748",
              }}
            >
              אחד
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: "#667eea",
                fontWeight: 500,
              }}
            >
              מדיטציה יהודית
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#718096",
                maxWidth: 300,
                mt: 1,
              }}
            >
              הורידו את האפליקציה והתחילו את המסע הרוחני שלכם
            </Typography>
          </Stack>

          {/* Download Buttons */}
          <Stack spacing={2} sx={{ width: "100%", maxWidth: 280 }}>
            {/* App Store */}
            <Button
              component="a"
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              size="large"
              startIcon={<Apple />}
              sx={{
                py: 1.5,
                px: 3,
                borderRadius: 3,
                background: "#000",
                color: "#fff",
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                "&:hover": {
                  background: "#1a1a1a",
                  transform: "translateY(-2px)",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.25)",
                },
                transition: "all 0.2s ease",
              }}
            >
              הורדה מ-App Store
            </Button>

            {/* Google Play */}
            <Button
              component="a"
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              size="large"
              startIcon={<ShopTwo />}
              sx={{
                py: 1.5,
                px: 3,
                borderRadius: 3,
                background: "linear-gradient(135deg, #01875f 0%, #34a853 100%)",
                color: "#fff",
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                boxShadow: "0 8px 24px rgba(1,135,95,0.3)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #017a56 0%, #2e9648 100%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 12px 32px rgba(1,135,95,0.4)",
                },
                transition: "all 0.2s ease",
              }}
            >
              הורדה מ-Google Play
            </Button>
          </Stack>

          {/* Footer */}
          <Typography
            variant="caption"
            sx={{
              color: "#a0aec0",
              mt: 2,
            }}
          >
            זמין עבור iOS ו-Android
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default DownloadAppPage;
